import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibContainer } from '@chewy/kib-layout-react'

import SwapPatient from '~/components/common/dialog/swapProduct/patientStep/SwapPatient'
import SwapProductAlert from '~/components/common/dialog/swapProduct/shared/SwapProductAlert'
import SwapProductDetails from '~/components/common/dialog/swapProduct/shared/SwapProductDetails'
import { getSwapProductTrackingData } from '~/constants/swapProductAnalytics'
import type { Prescription } from '~/types'
import { trackEvent, TrackingEvent } from '~/utils/trackingProvider'

import styles from './SwapPatientStep.module.scss'

interface SwapPatientStepProps {
  onPatientChange?: (patientId: string) => void
  onProceed?: (prescription: Prescription) => void
  prescription: Prescription
}

export function SwapPatientStep({
  prescription,
  onProceed,
  onPatientChange,
}: SwapPatientStepProps) {
  const changeType = 'patient'
  const { t } = useTranslation('Dialogs')
  const [patientId, setPatientId] = useState<string | null>(null)
  const [disableButton, setDisableButton] = useState(true)

  return (
    <div>
      <SwapProductAlert changeType={changeType} />
      <SwapProductDetails prescription={prescription} />
      <SwapPatient
        prescription={prescription}
        onChange={(newPatientId) => {
          setPatientId(newPatientId)
          setDisableButton(false)
          onPatientChange?.(newPatientId)
        }}
      />
      <KibContainer className={styles.buttonWrapper}>
        {onProceed && (
          <KibButtonNew
            disabled={disableButton}
            onClick={() => {
              trackEvent(
                TrackingEvent.SWAP_PATIENT_SEARCH_SELECT_PATIENT,
                getSwapProductTrackingData(
                  'SWAP_PATIENT_SEARCH_SELECT_PATIENT',
                  prescription,
                ),
              )
              const newPrescription: Prescription = {
                ...prescription,
                id: '',
                patientId,
                createdAt: undefined,
                updatedAt: undefined,
              }
              onProceed(newPrescription)
            }}
          >
            {t('SWAP_PRODUCT_DIALOG.PROCEED_BUTTON_LABEL', {
              changeType,
            })}
          </KibButtonNew>
        )}
      </KibContainer>
    </div>
  )
}
